import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { OfficialDiaryDetailProvider } from './context/official-diary-detail-context';
import { OfficialDiaryDetailComponent } from './official-diary-detail-component';

export function OfficialDiaryDetailFactory() {
    return (
        <BaseLayoutFactory>
            <OfficialDiaryDetailProvider>
                <OfficialDiaryDetailComponent />
            </OfficialDiaryDetailProvider>
        </BaseLayoutFactory>
    );
}
